import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import SellWithUs from "@/pages/SellWithUs";
import Lots from "@/pages/Lots";
import LotDetail from "@/pages/LotDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import BuyerAccount from "@/pages/BuyerAccount";
import SellerDashboard from "@/pages/SellerDashboard";
import SellerLotForm from "@/pages/SellerLotForm";
import AdminDashboard from "@/pages/AdminDashboard";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";

function Shell({ children }) {
  return (
    <div className="App flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="bottom-right" richColors />
        <Routes>
          <Route path="/" element={<Shell><Home /></Shell>} />
          <Route path="/how-it-works" element={<Shell><HowItWorks /></Shell>} />
          <Route path="/about" element={<Shell><About /></Shell>} />
          <Route path="/contact" element={<Shell><Contact /></Shell>} />
          <Route path="/sell" element={<Shell><SellWithUs /></Shell>} />
          <Route path="/lots" element={<Shell><Lots /></Shell>} />
          <Route path="/lots/:id" element={<Shell><LotDetail /></Shell>} />
          <Route path="/login" element={<Shell><Login /></Shell>} />
          <Route path="/register" element={<Shell><Register /></Shell>} />
          <Route path="/account" element={<ProtectedRoute><Shell><BuyerAccount /></Shell></ProtectedRoute>} />
          <Route path="/seller" element={<ProtectedRoute roles={["seller", "admin"]}><Shell><SellerDashboard /></Shell></ProtectedRoute>} />
          <Route path="/seller/new" element={<ProtectedRoute roles={["seller", "admin"]}><Shell><SellerLotForm /></Shell></ProtectedRoute>} />
          <Route path="/seller/edit/:id" element={<ProtectedRoute roles={["seller", "admin"]}><Shell><SellerLotForm /></Shell></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><Shell><AdminDashboard /></Shell></ProtectedRoute>} />
          <Route path="/terms-of-use" element={<Shell><LegalPage docKey="termsOfUse" /></Shell>} />
          <Route path="/privacy-policy" element={<Shell><LegalPage docKey="privacyPolicy" /></Shell>} />
          <Route path="/legal-disclaimer" element={<Shell><LegalPage docKey="legalDisclaimer" /></Shell>} />
          <Route path="*" element={<Shell><NotFound /></Shell>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
